import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';

import Button from '@Components/Button';


export default function InputToggler (props) {
  const {
    filter,
    onClickUserInput,
    disableUserInputToggler,
  } = props;
  const userInput = filter.get('userInput');
  const userInputOpen = filter.get('userInputOpen');

  return userInput === 'TEXT' ?
    (
      <Button
        onClick={onClickUserInput}
        disabled={disableUserInputToggler}
        buttonConfig={{ type: 'link', size: 'xs', label: 'Filter by value', e2eName: 'filter-by-value' }}
        iconConfig={{ name: `${userInputOpen ? 'chevron-up' : 'chevron-down'}`, size: 'tiny' }}
      />
    ) :
    <div className='bar-chart-filter-user-input-shadow' />
}

InputToggler.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
};
